import PeopleIcon from '@crehana/compass.icons.outline/People';

import { useCourseDetailTranslation } from '../../../hooks/useCourseDetailTranslation';

export const EnrollmentsCurrentCourseEmpty: React.FC = () => {
  const { t } = useCourseDetailTranslation();

  return (
    <div className="tw-bg-neutral-light-200 tw-p-1.6 tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-1.6 tw-h-24">
      <div className="tw-bg-neutral-light-400 tw-rounded-full tw-p-1.2 tw-mb-0.4 tw-border-0.8 tw-border-solid tw-border-neutral-light-300">
        <PeopleIcon
          className="tw-w-2.4 tw-h-2.4 tw-text-neutral-light-700"
          size={24}
        />
      </div>
      <p className="tw-font-subtitle6 tw-text-gray-800 tw-text-center">
        {t('ENROLLMENTS_CURRENT_COURSE_EMPTY')}
      </p>
    </div>
  );
};
